export default __webpack_public_path__ + "static/media/icon-cadenas.ec35a37d.svg";